import { useMutation } from "@tanstack/react-query";
import { confirmationToast, errorToast } from "@/components/ui/toast.tsx";
import { api } from "@/lib/http.ts";
import { describeLogoutOtherDevices } from "@/shared/logoutOtherDevices.ts";
import type { LogoutOtherDevicesResponse } from "@/types/sessions.ts";

/**
 * Log the user out of every device but this one and disconnect their MCP
 * clients, in one server call, then say what that ended. This device stays
 * logged in, so unlike Log out there is nothing to wipe here: the other
 * devices wipe themselves when their next request is refused.
 */
export const useLogoutOtherDevices = () =>
  useMutation({
    mutationFn: async () => {
      const { data } = await api.post<LogoutOtherDevicesResponse>("/api/a/users/logout-others");
      return data;
    },
    onSuccess: (outcome) => {
      confirmationToast(describeLogoutOtherDevices(outcome));
    },
    onError: () => {
      errorToast("Couldn't log out your other devices. Please try again.");
    },
  });
